/* eslint-disable max-lines-per-function */
/* eslint-disable sonarjs/no-duplicate-string */
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { sendAgreement } from 'Cloud/Application/User';
import { xray } from 'lib/xray';
import { isAttachSaveToAllDocuments, welcomeDefaultTariff } from 'reactApp/appHelpers/featuresHelpers';
import { renderCreateDocumentByQueryActionDialog } from 'reactApp/components/CreateDocumentByLinkDialog/createDocumentByLinkDialog.helpers';
import { renderLicenseAgreementDialog } from 'reactApp/components/LicenseAgreement/licenseAgreement.toolkit';
import type { IWelcomeAttachesRepeatingProps } from 'reactApp/components/WelcomeAttaches/WelcomeAttachesRepeating';
import { sendAuthDwhRequest } from 'reactApp/modules/dwh/dwh.module';
import { EAuthDwhAction } from 'reactApp/modules/dwh/dwh.types';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { chooseVariant } from 'reactApp/modules/features/features.helpers';
import { getFeatureRequiredSignUpWhenDownloading, getFeatureShowEditButtonForAttach } from 'reactApp/modules/features/features.selectors';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { DEFAULT_TARIFF_FORK_PROMO_ID, PERIOD_TO_SHOW_DAYS } from 'reactApp/modules/promo/sagas/defaultTariffForkModal.saga';
import { requiredAuthorizationHelpers } from 'reactApp/modules/requiredAuthorization/helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { showUploaderAction } from 'reactApp/modules/upload/upload.module';
import { acceptWelcomeLA } from 'reactApp/modules/welcome/welcome.module';
import { store as reduxStore } from 'reactApp/store';
import type { Product } from 'reactApp/types/Billing';
import { renderWelcomeDefaultTariffSplash } from 'reactApp/ui/WelcomeDefaultTariffSplash/WelcomeDefaultTariffSplash.heplers';
import {
    renderWelcomeAllDocumentsDialog,
    renderWelcomeDialog,
    renderWelcomeDialogNewAttaches,
    renderWelcomeRepeatingAttachesDialogHelper,
} from 'reactApp/ui/WelcomeDialog/WelcomeDialog.helpers';
import { sendXray } from 'reactApp/utils/ga';
import { noopVoid } from 'reactApp/utils/helpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

const showUploader = () => reduxStore.dispatch(showUploaderAction());

const groupAb = getFeature('ab-trial-popup');
// tempexp_15327-next-line
const allDocumentsWelcomeLicenceEnabled = getFeature('alldocuments-welcome-licence');

// tempexp_15327-next-line
const sendAllDocumentsWelcomeAnalytics = (type: 'show' | 'accept') => {
    xray.send(`alldocuments_welcome-licence_${type}`);
};

const sendFirstEnter = () =>
    sendPaymentGa({
        eventCategory: ECategoryGa.onboarding,
        action: 'first-enter',
        label: '',
        group: groupAb || 'None',
    });

let dialog;
export const renderWelcomeHelper = ({
    storage,
    onSuccess = noopVoid,
    onClose = noopVoid,
    newDialog,
    source = storage === EStorageType.attaches ? 'welcome_attaches' : 'welcome_promo',
    // tempexp_17086-next-line
    product,
}: {
    storage: EStorageType;
    onSuccess?();
    onClose?();
    newDialog?: boolean;
    source?: string;
    // tempexp_17086-next-line
    product?: Product;
}) => {
    const state = reduxStore.getState();

    const isPhone = EnvironmentSelectors.isPhone();

    const isAttachEdit =
        (storage === EStorageType.viewerAttaches || storage === EStorageType.attaches) && getFeatureShowEditButtonForAttach(state);

    // eslint-disable-next-line unicorn/consistent-function-scoping
    const onAccept = () => {
        onSuccess();
        sendFirstEnter();
        showUploader();
        renderCreateDocumentByQueryActionDialog();
        reduxStore.dispatch(acceptWelcomeLA());
    };

    // tempexp_17086-start
    const wasShown = storeHelper.getValue(DEFAULT_TARIFF_FORK_PROMO_ID);
    const periodPassed = storeHelper.isPassed(DEFAULT_TARIFF_FORK_PROMO_ID, { daysCount: PERIOD_TO_SHOW_DAYS });
    if (storage === EStorageType.home && welcomeDefaultTariff && !isPhone && product && (!wasShown || periodPassed)) {
        renderWelcomeDefaultTariffSplash({
            onContinue: () => {
                sendAgreement('welcome-splash');
                onAccept();
            },
            onClose: () => {
                reduxStore.dispatch(promoShown(EPromoType.defaultTariffFork));
                storeHelper.markAsShown(DEFAULT_TARIFF_FORK_PROMO_ID);
                reduxStore.dispatch(removePromo(EPromoType.defaultTariffFork));
            },
            product,
        });
        return;
    }
    // tempexp_17086-end

    if (storage === EStorageType.attaches && !isAttachSaveToAllDocuments) {
        renderWelcomeDialogNewAttaches({
            onSuccess: () => {
                sendAgreement(source);
                onAccept();
                onClose();
                reduxStore.dispatch(
                    sendAuthDwhRequest({
                        action: EAuthDwhAction.licenseAccept,
                        source: 'attaches',
                        place: storage,
                    })
                );
            },
            onShow: () => {
                reduxStore.dispatch(
                    sendAuthDwhRequest({
                        action: EAuthDwhAction.licenseOpen,
                        source: 'attaches',
                        place: storage,
                    })
                );
            },
        });
        return;
    }

    // tempexp_15327-next-line
    if ((storage === EStorageType.alldocuments || isAttachEdit) && (allDocumentsWelcomeLicenceEnabled || isAttachSaveToAllDocuments)) {
        renderWelcomeAllDocumentsDialog({
            onSuccess: () => {
                sendAgreement();
                onAccept();
                onClose();
                sendAllDocumentsWelcomeAnalytics('accept');
                reduxStore.dispatch(
                    sendAuthDwhRequest({
                        action: EAuthDwhAction.licenseAccept,
                        source: 'alldocuments',
                    })
                );
            },
            onShow: () => {
                sendAllDocumentsWelcomeAnalytics('show');
                reduxStore.dispatch(
                    sendAuthDwhRequest({
                        action: EAuthDwhAction.licenseOpen,
                        source: 'alldocuments',
                    })
                );
            },
        });
        return;
    }

    if (isPhone) {
        renderLicenseAgreementDialog({
            source: 'touch',
            closable: false,
            place: storage,
            onSuccess: () => {
                onAccept();
            },
        });

        return;
    }

    /* tempexp_15344-next-line */
    const newWelcomDialog_tempexp_15344 = newDialog || requiredAuthorizationHelpers.isSuccessAuthWhenDownload(state);

    const welcomeSource = 'welcome_promo';

    if (
        /* tempexp_15344-next-line */
        chooseVariant(getFeatureRequiredSignUpWhenDownloading, {
            control: newDialog,
            variant1: newWelcomDialog_tempexp_15344,
        })()
    ) {
        renderWelcomeDialogNewAttaches({
            onSuccess: () => {
                sendAgreement(welcomeSource);
                onAccept();
                onClose();
                reduxStore.dispatch(
                    sendAuthDwhRequest({
                        action: EAuthDwhAction.licenseAccept,
                        source: isAttachEdit ? 'edit-attace-copy' : 'none',
                        place: storage,
                    })
                );
            },
            onShow: () => {
                reduxStore.dispatch(
                    sendAuthDwhRequest({
                        action: EAuthDwhAction.licenseOpen,
                        source: isAttachEdit ? 'edit-attace-copy' : 'none',
                        place: storage,
                    })
                );
            },
        });
    } else {
        renderWelcomeDialog({
            onSuccess: showUploader,
            // eslint-disable-next-line sonarjs/no-identical-functions
            onClose: () => {
                sendAgreement(welcomeSource);
                onAccept();
                onClose();
                reduxStore.dispatch(
                    sendAuthDwhRequest({
                        action: EAuthDwhAction.licenseAccept,
                        source: isAttachEdit ? 'edit-attace-copy' : 'none',
                        place: storage,
                    })
                );
            },
            onShow: () =>
                reduxStore.dispatch(
                    sendAuthDwhRequest({
                        action: EAuthDwhAction.licenseOpen,
                        source: isAttachEdit ? 'edit-attace-copy' : 'none',
                        place: storage,
                    })
                ),
        });
    }
};

export const isWelcomeDialogShown = (): boolean => !!dialog;

export interface WelcomeRepeatingHelperHandler {
    (data: { storage: EStorageType }): void;
}

const ATTACHES_REPEATING_RADAR = 'repeat_welcome_attaches';

export const renderWelcomeRepeatingHelper: WelcomeRepeatingHelperHandler = ({ storage }) => {
    if (storage !== EStorageType.attaches || isWelcomeDialogShown()) {
        return;
    }
    const params: IWelcomeAttachesRepeatingProps = {
        onClose: () => {
            sendXray(ATTACHES_REPEATING_RADAR, {
                show: 1,
            });
            dialog = null;
        },
        onAccept: () => {
            sendXray(ATTACHES_REPEATING_RADAR, {
                accept: 1,
            });
            dialog?.close?.();
        },
        onShow: () => {
            sendXray(ATTACHES_REPEATING_RADAR, {
                show: 1,
            });
        },
    };
    dialog = renderWelcomeRepeatingAttachesDialogHelper(params);
};
